import vsComponent from './vsInput';

export default Vue => {
  Vue.component(vsComponent.name, vsComponent);
};
